export const SHOW_TRANSACTION_TYPES = {
  ALL: 'all',
  OWN: 'own',
}

export const YES_OR_NO = {
  NO: 'no',
  YES: 'yes',
}
